/** Identificador da situação cadastral da empresa */
export interface EmpresaSituacaoCadastral {
    id: number;
    nome: string;
}

export const empresaSituacaoCadastralNula: EmpresaSituacaoCadastral = {id: 1, nome: 'Nula'};
export const empresaSituacaoCadastralAtiva: EmpresaSituacaoCadastral = {id: 2, nome: 'Ativa'};
export const empresaSituacaoCadastralSuspensa: EmpresaSituacaoCadastral = {id: 3, nome: 'Suspensa'};
export const empresaSituacaoCadastralInapta: EmpresaSituacaoCadastral = {id: 4, nome: 'Inapta'};
export const empresaSituacaoCadastralBaixada: EmpresaSituacaoCadastral = {id: 8, nome: 'Baixada'};

export const empresaSituacoesCadastrais: EmpresaSituacaoCadastral[] = [
    empresaSituacaoCadastralNula,
    empresaSituacaoCadastralAtiva,
    empresaSituacaoCadastralSuspensa,
    empresaSituacaoCadastralInapta,
    empresaSituacaoCadastralBaixada
];

/** Verifica se a situação cadastral é Nula */
export function isSituacaoCadastralNula(situacaoCadastral: number): boolean {
    return situacaoCadastral === empresaSituacaoCadastralNula.id;
}

/** Verifica se a situação cadastral é Ativa */
export function isSituacaoCadastralAtiva(situacaoCadastral: number): boolean {
    return situacaoCadastral === empresaSituacaoCadastralAtiva.id;
}

/** Verifica se a situação cadastral é Suspensa */
export function isSituacaoCadastralSuspensa(situacaoCadastral: number): boolean {
    return situacaoCadastral === empresaSituacaoCadastralSuspensa.id;
}

/** Verifica se a situação cadastral é Inapta */
export function isSituacaoCadastralInapta(situacaoCadastral: number): boolean {
    return situacaoCadastral === empresaSituacaoCadastralInapta.id;
}

/** Verifica se a situação cadastral é Baixada */
export function isSituacaoCadastralBaixada(situacaoCadastral: number): boolean {
    return situacaoCadastral === empresaSituacaoCadastralBaixada.id;
}
